import { isRecord } from "../types/data";

const CACHE_PREFIX = "cineparagon_background_url_v1";

const getCacheKey = (userId: string, type: string) =>
  `${CACHE_PREFIX}:${String(userId || "")}:${type}`;

const isSafeBackgroundUrl = (value: unknown): value is string => {
  try {
    return typeof value === "string" && new URL(value).protocol === "https:";
  } catch {
    return false;
  }
};

// This is intentionally only a paint-time cache. The URL remains in Firestore
// and is revalidated by UserBackgroundContext after the first render.
export const readCachedBackgroundUrl = (userId: string, type: string) => {
  if (!userId || typeof localStorage === "undefined") return "";
  try {
    const saved: unknown = JSON.parse(localStorage.getItem(getCacheKey(userId, type)) || "null");
    return isRecord(saved) && isSafeBackgroundUrl(saved.url) ? saved.url : "";
  } catch {
    return "";
  }
};

export const writeCachedBackgroundUrl = (userId: string, type: string, url: string) => {
  if (!userId || typeof localStorage === "undefined" || !isSafeBackgroundUrl(url)) return;
  try {
    localStorage.setItem(getCacheKey(userId, type), JSON.stringify({
      url,
      savedAt: Date.now()
    }));
  } catch {
    // Rendering works without this optional cache; storage quotas must not
    // affect profile appearance or its Firestore-backed persistence.
  }
};

export const clearCachedBackgroundUrl = (userId: string, type: string) => {
  if (!userId || typeof localStorage === "undefined") return;
  try {
    localStorage.removeItem(getCacheKey(userId, type));
  } catch {
    // no-op
  }
};
